import { put, select, call } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import { mapActivityData } from 'utils/activities'
import camelCaseKeys from 'utils/camelCaseKeys'
import {
  setListId as setCardListId,
  setName as setCardName,
  setDueDate as setCardDueDate,
  setDueDateId as setCardDueDateId,
  setStartDate as setCardStartDate,
  setStartDateId as setCardStartDateId,
  setArchived as setCardArchived,
  addLabel,
  removeLabel,
  setResponsible,
  removeResponsible,
  addUser,
  removeUser,
  setStatus as setCardStatus
} from 'routes/Board/redux/cards'
import {
  init,
  setLoadStatus,
} from 'routes/Card/redux/view'
import {
  setIsCardInMyBoard,
  setMyBoard
} from 'routes/Card/redux/myBoard'
import {
  add as addDate,
  remove as removeDate,
  setName as setDateName,
  setTimestamp as setDateTimestamp
} from 'routes/Card/redux/dates'
import {
  add as addObserver,
  remove as removeObserver
} from 'routes/Card/redux/observers'
import {
  add as addVisitor
} from 'routes/Card/redux/visitors'
import {
  add as addElement,
  remove as removeElement,
  set as setElement,
  setName as setElementName,
  setContent as setElementContent,
  addItem as addItemToElement,
  removeItem as removeItemFromElement,
  positionItems as positionElementItems,
  setPositions as setElementPositions
} from 'routes/Card/redux/elements'
import {
  add as addChecklistItem,
  remove as removeChecklistItem,
  setName as setChecklistItemName,
  setCompleted as setChecklistItemCompleted
} from 'routes/Card/redux/checklistItems'
import {
  add as addDocumentListItem,
  addArray as addDocumentListItemsArray,
  remove as removeDocumentListItem,
  setByUrl as setDocumentListItemByUrl,
} from 'routes/Card/redux/documentListItems'
import {
  add as addSubCard,
  remove as removeSubCard
} from 'routes/Card/redux/subCards'
import {
  add as addActivity,
  remove as removeActivity,
  set as setActivity
} from 'routes/Card/redux/activities'
import {
  addCardRelation,
  removeCardRelation
} from 'store/redux/cardRelations'
import {
  add as addAlarm,
  remove as removeAlarm
} from 'store/redux/alarms'
import fetchView from 'routes/Card/sagas/fetchView'

export default function * channelData ({ cardId }, action) {
  const { channel, actionName, elementName, data } = action.payload

  const state = yield select()

  if (!state['view-board'].cards[cardId]) return

  const boardId = state['view-board'].cards[cardId].boardId

  const currentUserId = state.kanbo.currentUser.id
  const myBoardId = state.kanbo.currentUser.myBoardId

  if (actionName + elementName === 'RenameFile/Data/RenameFile') {
    yield put(setDocumentListItemByUrl({
      documentSourceId: data.DocumentSourceId,
      url: data.OldUrl,
      newUrl: data.NewUrl,
      name: data.NewName
    }))
  } else if (channel === 'card-' + cardId) {
    if (actionName + elementName === 'RemoveCard/Data/Card') {
      yield put(init({
        cardId,
      }))
      yield put(setLoadStatus({
        cardId,
        isLoading: false,
        isLoaded: false
      }))
    } else if (actionName === 'MoveCard') {
      yield put(fetchView({
        cardId
      }))
    } else if (actionName + elementName === 'RenameCard/Data/IdName') {
      const { Name } = data
      yield put(setCardName({
        id: cardId,
        name: Name
      }))
    } if (actionName + elementName === 'ChangeCardParent/Data/CardMove') {
      const { ContainerToId } = data
      yield put(setCardListId({
        id: cardId,
        listId: ContainerToId
      }))
    } else if (
      actionName === 'ArchiveCard' ||
      actionName === 'ArchiveCardsInList' ||
      actionName === 'ArchiveCardsInStatus' ||
      actionName === 'ArchiveCardsWithLabel' ||
      actionName === 'ArchiveCardsWithUser'
    ) {
      yield put(setCardArchived({
        id: cardId,
        isArchived: true
      }))
      yield put(setCardListId({
        id: cardId,
        listId: undefined
      }))
    } else if (actionName + elementName === 'UnarchiveCard/Data/CardFront') {
      const { ListId } = data
      yield put(setCardListId({
        id: cardId,
        listId: ListId
      }))
      yield put(setCardArchived({
        id: cardId,
        isArchived: false
      }))
    } else if (actionName + elementName === 'AddLabelToCard/Data/Label') {
      const { Id } = data
      yield put(addLabel({
        id: cardId,
        labelId: Id
      }))
    } else if (actionName + elementName === 'RemoveLabelFromCard/Data/LabelInCard') {
      const { LabelId } = data
      yield put(removeLabel({
        id: cardId,
        labelId: LabelId
      }))
    } else if (actionName + elementName === 'SetDueDate/Data/CalendarEvent') {
      const { Id, Timestamp } = data
      yield put([
        setCardDueDate({
          id: cardId,
          dueDate: Timestamp
        }),
        setCardDueDateId({
          id: cardId,
          dueDateId: Id
        })
      ])
    } else if (actionName + elementName === 'RemoveDueDate/Data/CardDate') {
      yield put([
        setCardDueDate({
          id: cardId,
          dueDate: null
        }),
        setCardDueDateId({
          id: cardId,
          dueDateId: null
        })
      ])
    } else if (actionName + elementName === 'SetStartDate/Data/CalendarEvent') {
      const { Id, Timestamp } = data
      yield put([
        setCardStartDate({
          id: cardId,
          startDate: Timestamp
        }),
        setCardStartDateId({
          id: cardId,
          startDateId: Id
        })
      ])
    } else if (actionName + elementName === 'RemoveStartDate/Data/CardDate') {
      yield put([
        setCardStartDate({
          id: cardId,
          startDate: null
        }),
        setCardStartDateId({
          id: cardId,
          startDateId: null
        })
      ])
    } else if (actionName + elementName === 'AddCustomDate/Data/CalendarEvent') {
      const CustomDate = data
      yield put(addDate({
        cardId,
        date: {
          id: CustomDate.Id,
          timestamp: CustomDate.Timestamp,
          name: CustomDate.Name
        }
      }))
    } else if (actionName + elementName === 'RemoveCustomDate/Data/CalendarEvent') {
      const CustomDate = data
      yield put(removeDate({
        cardId,
        dateId: CustomDate.Id
      }))
    } else if (actionName + elementName === 'RenameCustomDate/Data/CalendarEvent') {
      const CustomDate = data
      yield put(setDateName({
        cardId,
        dateId: CustomDate.Id,
        name: CustomDate.Name
      }))
    } else if (actionName + elementName === 'SetCustomDate/Data/CalendarEvent') {
      const CustomDate = data
      yield put(setDateTimestamp({
        cardId,
        dateId: CustomDate.Id,
        timestamp: CustomDate.Timestamp
      }))
    } else if (actionName + elementName === 'AddNote/Data/Note') {
      const { Id, Name, ElementName, Text } = data

      yield put(addElement({
        cardId,
        element: {
          id: Id,
          elementName: ElementName,
          name: Name,
          content: JSON.parse(Text)
        }
      }))
    } else if (actionName + elementName === 'AddChecklist/Data/Checklist') {
      const { Id, Name, ElementName } = data

      yield put(addElement({
        cardId,
        element: {
          id: Id,
          elementName: ElementName,
          name: Name,
          items: []
        }
      }))
    } else if (actionName + elementName === 'AddDocumentsList/Data/DocumentsList') {
      const { Id, Name, ElementName } = data

      yield put(addElement({
        cardId,
        element: {
          id: Id,
          elementName: ElementName,
          name: Name,
          items: []
        }
      }))
    } else if (actionName + elementName === 'AddDocumentsFolder/Data/DocumentsFolder') {
      const { Id, Name, ElementName, Settings, DocumentSourceId, Path, FullUrl } = data

      yield put(addElement({
        cardId,
        element: {
          id: Id,
          elementName: ElementName,
          name: Name,
          documentSourceId: DocumentSourceId,
          path: Path,
          fullUrl: FullUrl,
          settings: Settings,
        }
      }))
    } else if (actionName + elementName === 'AddDocumentsFolderCreator/Data/DocumentsFolderCreator') {
      const { Id, Name, ElementName, Settings, DocumentSourceId, Path, FullUrl } = data

      yield put(addElement({
        cardId,
        element: {
          id: Id,
          elementName: ElementName,
          name: Name,
          documentSourceId: DocumentSourceId,
          path: Path,
          fullUrl: FullUrl,
          settings: Settings,
        }
      }))
    } else if (actionName + elementName === 'AddSubCardGroup/Data/SubCardGroup') {
      const { Id, Name, ElementName } = data

      yield put(addElement({
        cardId,
        element: {
          id: Id,
          elementName: ElementName,
          name: Name,
          items: []
        }
      }))
    } else if (actionName + elementName === 'RemoveElement/Data/ElementWithCount') {
      const { Id } = data

      yield put(removeElement({
        cardId,
        elementId: Id
      }))
    } else if (actionName + elementName === 'RenameElement/Data/Element') {
      const { Id, Name } = data
      yield put(setElementName({
        elementId: Id,
        name: Name
      }))
    } else if (elementName === '/Positions/Elements') {
      const { Positions } = data
      let positionsById = {}
      Positions.forEach(list => {
        positionsById[list.Id] = list.Position
      })
      yield put(setElementPositions({
        cardId,
        positionsById
      }))
    } else if (actionName + elementName === 'ChangeNoteContent/Data/Note') {
      const { Id, Text } = data

      yield put(setElementContent({
        elementId: Id,
        content: JSON.parse(Text)
      }))
    } else if (actionName + elementName === 'ChangeDocumentsFolderPath/Data/DocumentsFolder') {
      const { DocumentsFolderId, DocumentSourceId, Path, FullUrl } = data

      yield put(setElement({
        cardId,
        element: {
          id: DocumentsFolderId,
          documentSourceId: DocumentSourceId,
          path: Path,
          fullUrl: FullUrl,
        }
      }))
    } else if (actionName + elementName === 'ChangeDocumentFolderSettings/Data/ChangeDocumentListSettings') {
      const { DocumentFolderId, Settings } = data

      yield put(setElement({
        cardId,
        element: {
          id: DocumentFolderId,
          settings: Settings,
        }
      }))
    } else if (actionName + elementName === 'ChangeDocumentsFolderCreatorPath/Data/DocumentsFolderCreator') {
      const { DocumentsFolderCreatorId, DocumentSourceId, Path, FullUrl } = data

      yield put(setElement({
        cardId,
        element: {
          id: DocumentsFolderCreatorId,
          documentSourceId: DocumentSourceId,
          path: Path,
          fullUrl: FullUrl,
        }
      }))
    } else if (actionName + elementName === 'AddChecklistItem/Data/ChecklistItem') {
      const { ContainerId, Id, Name, Completed, UserId, Timestamp } = data

      yield put(addChecklistItem({
        cardId,
        checklistItem: {
          id: Id,
          name: JSON.parse(Name),
          completed: Completed,
          userId: UserId,
          dueDate: Timestamp
        }
      }))
      yield put(addItemToElement({
        elementId: ContainerId,
        itemId: Id
      }))
    } else if (actionName + elementName === 'RemoveChecklistItem/Data/ChecklistItem') {
      const { ContainerId, Id } = data

      yield put(removeItemFromElement({
        elementId: ContainerId,
        itemId: Id
      }))
      yield put(removeChecklistItem({
        cardId,
        checklistItemId: Id
      }))
    } else if (
      actionName + elementName === 'CompleteChecklistItem/Data/ChecklistItem' ||
      actionName + elementName === 'UncompleteChecklistItem/Data/ChecklistItem'
    ) {
      const { Id, Completed } = data

      yield put(setChecklistItemCompleted({
        cardId,
        checklistItemId: Id,
        completed: Completed
      }))
    } else if (actionName + elementName === 'RenameChecklistItem/Data/ChecklistItem') {
      const { Id, Name } = data

      yield put(setChecklistItemName({
        cardId,
        checklistItemId: Id,
        name: JSON.parse(Name)
      }))
    } else if (actionName + elementName === 'ConvertChecklistItemToCard/Data/ConvertedChecklistItem/ChecklistItem') {
      const { ChecklistId, Id } = data

      yield put(removeItemFromElement({
        elementId: ChecklistId,
        itemId: Id
      }))
      yield put(removeChecklistItem({
        cardId,
        checklistItemId: Id
      }))
    } else if (elementName === '/Positions/ChecklistItems') {
      const { ContainerId, Positions } = data
      let positionsById = {}
      Positions.forEach(list => {
        positionsById[list.Id] = list.Position
      })
      yield put(positionElementItems({
        elementId: ContainerId,
        positionsById
      }))
    } else if (actionName + elementName === 'ChangeParent/Data/Move<ChecklistItem>') {
      const { ContainerFromId, ContainerToId, ElementId, Position } = data
      yield put(removeItemFromElement({
        elementId: ContainerFromId,
        itemId: ElementId
      }))
      yield put(addItemToElement({
        elementId: ContainerToId,
        itemId: ElementId,
        index: Position
      }))
    } else if (actionName + elementName === 'AddDocumentsListItem/Data/DocumentsListItem' ||
               actionName + elementName === 'AddDocumentToCard/Data/DocumentsListItem') {
      const Document = data

      yield put(addDocumentListItem({
        id: Document.Id,
        url: Document.Url,
        name: Document.Name,
        size: Document.Size,
        sourceId: Document.SourceId,
        lastModificationTimestamp: Document.LastModificationTimestamp,
        exists: Document.Exists,
        thumbnailUrl: Document.ThumbnailUrl,
        actions: Document.Actions ? Document.Actions.map(camelCaseKeys) : [],
        position: Document.Position,
        isLoaded: true,
        isLoading: false,
      }))

      yield put(addItemToElement({
        elementId: Document.ContainerId,
        itemId: Document.Id
      }))
    } else if (actionName + elementName === 'RemoveDocumentsListItem/Data/DocumentsListItem') {
      const Document = data

      yield put(removeItemFromElement({
        elementId: Document.ContainerId,
        itemId: Document.Id
      }))

      yield put(removeDocumentListItem(Document.Id))
    } else if (actionName + elementName === 'EventDocumentRemove/Data/ListItems') {
      const { ListItems } = data

      const length = ListItems.length
      for (let i = 0; i < length; i++) {
        const ListItem = ListItems[i]

        yield put(removeItemFromElement({
          elementId: ListItem.ContainerId,
          itemId: ListItem.Id
        }))

        yield put(removeDocumentListItem(ListItem.Id))
      }
    } else if (actionName + elementName === 'EventDocumentMove/Data/ListItemsChanges') {
      const { ListItems } = data

      yield put(addDocumentListItemsArray(ListItems.map(ListItem => {
        const Document = ListItem.Data

        return {
          id: ListItem.Id,
          url: Document.Url,
          name: Document.Name,
          size: Document.Size,
          sourceId: Document.SourceId,
          lastModificationTimestamp: Document.LastModificationTimestamp,
          exists: Document.Exists,
          thumbnailUrl: Document.ThumbnailUrl,
          actions: Document.Actions ? Document.Actions.map(camelCaseKeys) : [],
          position: Document.Position,
          isLoaded: true,
          isLoading: false,
        }
      })))
    } else if (elementName === '/Positions/DocumentsListItems') {
      const { ContainerId, Positions } = data
      let positionsById = {}
      Positions.forEach(list => {
        positionsById[list.Id] = list.Position
      })
      yield put(positionElementItems({
        elementId: ContainerId,
        positionsById
      }))
    } else if (actionName + elementName === 'ChangeParent/Data/Move<DocumentsListItem>') {
      const { ContainerFromId, ContainerToId, ElementId, Position } = data
      yield put(removeItemFromElement({
        elementId: ContainerFromId,
        itemId: ElementId
      }))
      yield put(addItemToElement({
        elementId: ContainerToId,
        itemId: ElementId,
        index: Position
      }))
    } else if (actionName + elementName === 'AddSubCardGroupItem/Data/SubCardGroupItem') {
      const { GroupId, Id, ChildId } = data

      yield put([
        addSubCard({
          cardId,
          subCard: {
            id: Id,
            cardId: ChildId,
          }
        }),
        addItemToElement({
          elementId: GroupId,
          itemId: Id
        })
      ])
    } else if (actionName + elementName === 'RemoveSubCardGroupItem/Data/SubCardGroupItem') {
      const { GroupId, Id } = data

      yield put([
        removeSubCard({
          cardId,
          subCardId: Id
        }),
        removeItemFromElement({
          elementId: GroupId,
          itemId: Id
        })
      ])
    } else if (elementName === '/Positions/SubCardGroupItems') {
      const { ContainerId, Positions } = data
      let positionsById = {}
      Positions.forEach(list => {
        positionsById[list.Id] = list.Position
      })
      yield put(positionElementItems({
        elementId: ContainerId,
        positionsById
      }))
    } else if (actionName + elementName === 'ChangeParent/Data/Move<SubCardGroupItem>') {
      const { ContainerFromId, ContainerToId, ElementId, Position } = data
      yield put(removeItemFromElement({
        elementId: ContainerFromId,
        itemId: ElementId
      }))
      yield put(addItemToElement({
        elementId: ContainerToId,
        itemId: ElementId,
        index: Position
      }))
    } else if (actionName + elementName === 'AddUserToCard/Data/CardUser') {
      const { Id, IsResponsible } = data
      if (IsResponsible) {
        yield put(setResponsible({
          id: cardId,
          responsible: Id
        }))
      } else {
        yield put(addUser({
          id: cardId,
          userId: Id
        }))
      }
    } else if (actionName + elementName === 'RemoveUserFromCard/Data/CardUser') {
      const { Id, IsResponsible } = data
      if (IsResponsible) {
        yield put(removeResponsible({
          id: cardId
        }))
      } else {
        yield put(removeUser({
          id: cardId,
          userId: Id
        }))
      }
    } else if (actionName + elementName === 'MakeUserResponsible/Data/CardUser') {
      const { Id } = data

      yield put(setResponsible({
        id: cardId,
        responsible: Id
      }))
    } else if (actionName + elementName === 'AddObservedTag/Data/Tag') {
      const { UserId } = data
      yield put(addObserver({
        cardId,
        userId: UserId
      }))
    } else if (actionName + elementName === 'RemoveObservedTag/Data/Tag') {
      const { UserId } = data
      yield put(removeObserver({
        cardId,
        userId: UserId
      }))
    } else if (actionName + elementName === 'SetCardStatus/Card/Status') {
      const { CardStatusId } = data
      yield put(setCardStatus({
        id: cardId,
        statusId: CardStatusId
      }))
    } else if (actionName + elementName === 'Heartbeat/Data/Heartbeats') {
      const { UserId, Timestamp } = data
      yield put(addVisitor({
        cardId,
        visitor: {
          id: UserId,
          timestamp: Timestamp
        }
      }))
    } else if (actionName + elementName === 'AddCardSuccessor/Data/CardSequence') {
      const { PredCardId, SuccCardId } = data

      yield put([
        addCardRelation({
          id: PredCardId,
          successorIds: [SuccCardId]
        }),
        addCardRelation({
          id: SuccCardId,
          predecessorIds: [PredCardId]
        })
      ])
    } else if (actionName + elementName === 'AddCardParent/Data/CardParent') {
      const { CardId, ParentCardId } = data

      yield put([
        addCardRelation({
          id: ParentCardId,
          childIds: [CardId]
        }),
        addCardRelation({
          id: CardId,
          parentIds: [ParentCardId],
        })
      ])
    } else if (actionName + elementName === 'RemoveCardSuccessor/Data/CardSequence') {
      const { PredCardId, SuccCardId } = data

      yield put([
        removeCardRelation({
          id: PredCardId,
          successorIds: [SuccCardId]
        }),
        removeCardRelation({
          id: SuccCardId,
          predecessorIds: [PredCardId]
        })
      ])
    } else if (actionName + elementName === 'RemoveCardParent/Data/CardParent') {
      const { CardId, ParentCardId } = data

      yield put([
        removeCardRelation({
          id: ParentCardId,
          childIds: [CardId]
        }),
        removeCardRelation({
          id: CardId,
          parentIds: [ParentCardId],
        })
      ])
    } else if (actionName + elementName === 'AddAlarm/Data/Alarm') {
      const Alarm = data

      yield put(addAlarm({
        id: Alarm.Id,
        eventId: Alarm.EventId,
        timestamp: Alarm.Timestamp,
        isDefault: Alarm.IsDefault
      }))
    } else if (actionName + elementName === 'RemoveAlarm/Data/Alarm') {
      const { Id } = data

      yield put(removeAlarm(Id))
    }
  } else if (channel === 'activity-card-' + cardId) {
    if (actionName + elementName === 'AddNotification/Data/Notification') {
      const activity = mapActivityData(data)

      if (activity.data.replacedNotificationId) {
        yield put(removeActivity({
          cardId,
          activityId: activity.data.replacedNotificationId,
        }))
      }

      yield put(addActivity({
        cardId,
        activity,
      }))
    }
  } else if (channel === '@' + currentUserId) {
    if (actionName + elementName === 'AddBookmark/Data/BookmarkData') {
      const { ActivityId } = data

      yield put(setActivity({
        cardId,
        activity: {
          id: ActivityId,
          isBookmarked: true
        }
      }))
    } else if (actionName + elementName === 'RemoveBookmark/Primitive/Int32') {
      const { Value } = data

      yield put(setActivity({
        cardId,
        activity: {
          id: Value,
          isBookmarked: false
        }
      }))
    }
  } else if (channel === 'vboard-' + myBoardId) {
    if (actionName + elementName === 'AddVCard/Data/VCard') {
      const { CardId } = data
      if (CardId === cardId) {
        try {
          const MyBoard = yield call(apiGetData, 'CardInMyBoard', { cardId })

          yield put(setIsCardInMyBoard({
            cardId,
            isCardInMyBoard: true
          }))

          yield put(setMyBoard({
            cardId,
            myBoard: {
              vCardId: MyBoard.VCardId,
              vListId: MyBoard.VListId,
              vListName: MyBoard.VListName
            }
          }))
        } catch (e) {}
      }
    } else if (actionName + elementName === 'AddCardsToMyBoard/Data/VCardData[]') {
      const VCards = data

      const length = VCards.length
      for (let i = 0; i < length; i++) {
        if (VCards[i].CardId === cardId) {
          try {
            const MyBoard = yield call(apiGetData, 'CardInMyBoard', { cardId })

            yield put(setIsCardInMyBoard({
              cardId,
              isCardInMyBoard: true
            }))

            yield put(setMyBoard({
              cardId,
              myBoard: {
                vCardId: MyBoard.VCardId,
                vListId: MyBoard.VListId,
                vListName: MyBoard.VListName
              }
            }))
          } catch (e) {}
          break
        }
      }
    } else if (actionName + elementName === 'RemoveVCard/Data/VCard') {
      const { CardId } = data
      if (CardId === cardId) {
        yield put(setIsCardInMyBoard({
          cardId,
          isCardInMyBoard: false
        }))
      }
    } else if (actionName + elementName === 'RemoveCardsInVList/Data/VListCards') {
      const { CardIds } = data

      if (CardIds.indexOf(cardId) !== -1) {
        yield put(setIsCardInMyBoard({
          cardId,
          isCardInMyBoard: false
        }))
      }
    } else if (actionName + elementName === 'ChangeParent/Data/Move<VCard>') {
      const { ElementId } = data
      const currentMyBoard = state['view-card'].myBoard[cardId].myBoard

      if (currentMyBoard && currentMyBoard.vCardId === ElementId) {
        try {
          const MyBoard = yield call(apiGetData, 'CardInMyBoard', { cardId })

          yield put(setMyBoard({
            cardId,
            myBoard: {
              vCardId: MyBoard.VCardId,
              vListId: MyBoard.VListId,
              vListName: MyBoard.VListName
            }
          }))
        } catch (e) {}
      }
    }
  }
}
